import { useQueries, useQuery } from '@tanstack/react-query';
import { APIKey, apiRoutes } from 'constants/apiKeys';
import baseFetcher from 'shared/helpers/baseFetcher';

export type Department = {
  id: string;
  name: string;
};

export type SiteDepartments = {
  siteId: string;
  departments: Department[];
};

export function useDepartments() {
  return useQuery<Department[]>({
    queryKey: [APIKey.DEPARTMENTS],
    queryFn: () => baseFetcher(apiRoutes.departments()),
  });
}

export function useDepartmentsForSites(siteIds: string[]) {
  return useQueries({
    queries: siteIds.map((siteId) => ({
      queryKey: [APIKey.DEPARTMENTS, siteId],
      queryFn: (): Promise<Department[]> =>
        baseFetcher(`${apiRoutes.departments()}?site_id=${siteId}`),
    })),
    combine: (results) => ({
      departmentsBySite: siteIds.map(
        (siteId, index): SiteDepartments => ({
          siteId,
          departments: results[index]?.data ?? [],
        })
      ),
      isSuccess: results.every((result) => result.isSuccess),
    }),
  });
}
